<header-section *ngIf="ShowHeader"></header-section>
<router-outlet></router-outlet>
<footer-section *ngIf="ShowFooter"></footer-section>